export default "/images/cde05d4a697e026c60c2259a61abac74.avif";